export const CHAT_BOX_WIDTH = 805;
export const BUTTON_CHAT_SIZE = 64;
export const CLOSE_ICON_SIZE = 32;
export const CHAT_ICON_SIZE = 24;
export const CHAT_BOX_BOTTOM_GAP = 40;
